import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { PasswordComponent } from './password/password.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SettingsService } from '../settings/settings.service';
import { MaterialModule } from '../material/material.module';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-info',
  standalone: true,
  imports: [
    MaterialModule,
    ReactiveFormsModule,
    CommonModule,
    PasswordComponent,
  ],
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.less'],
})
export class InfoComponent implements OnInit {
  formGroup: FormGroup;
  showSpinner: boolean = false;

  constructor(
    fb: FormBuilder,
    public snackBar: MatSnackBar,
    public settings: SettingsService
  ) {
    this.formGroup = fb.group({
      first_name: ['', Validators.required],
      last_name: ['', Validators.required],
      email: [{ value: '', disabled: true }],
    });
  }

  ngOnInit() {
    this.getProfile();
  }

  async getProfile() {
    try {
      const response: any = await this.settings.get_query(1, '/cliente-inversionista/profile/');
      const data = response._body.info;
      this.formGroup.patchValue({
        first_name: data.first_name,
        last_name: data.last_name,
        email: data.email,
      });
    } catch (error) {
      console.error('Error al obtener perfil:', error);
    }
  }

  async submitProfile() {
    if (!this.formGroup.valid) return;
    this.showSpinner = true;
    try {
      const formData = {
        first_name: this.formGroup.getRawValue().first_name,
        last_name: this.formGroup.getRawValue().last_name,
      };
      await this.settings.get_query(2, '/cliente-inversionista/profile/', formData);
      this.snackBar.open('Datos actualizados', 'Cerrar', {
        duration: 3000,
        panelClass: 'simpli-snack',
      });
    } catch (error) {
      this.snackBar.open('Error al actualizar', 'Cerrar', {
        duration: 3000,
        panelClass: 'simpli-snack',
      });
    } finally {
      this.showSpinner = false;
    }
  }
}
